export default __webpack_public_path__ + "static/media/nooffers-dark.e353bd6c.svg";